import { Card, Checkbox, Description, Image } from "@geist-ui/core";
import React from "react";
import ShowMoreText from "react-show-more-text";
import "./styles.css";

function ValueItem(props) {
  const { data, isDisabled } = props;

  return (
    <Checkbox {...props} disabled={isDisabled} value={data}>
      {/* width={"calc((100vw - 4em) * 1/4 + 3em)"} */}
      <Card hoverable width={"325px"}>
        {data.imageSrc ? (
          <Image
            src={data.imageSrc}
            height="200px"
            width="325px"
            draggable={false}
          />
        ) : null}
        <h2 className="cardTitle">{data.value}</h2>
        {data.description ? (
          <ShowMoreText
            lines={3}
            more={"Read More"}
            className="cardDescription"
            expanded={false}
          >
            {data.description}
          </ShowMoreText>
        ) : null}
        {/* <Description title={data.value} content={data.description} /> */}
      </Card>
    </Checkbox>
  );
}

export default ValueItem;
